import { useState, useEffect } from 'react';

// All layout in this app is inline style={{}} (see AGENTS.md) - that can't contain
// @media queries, so responsive behavior has to be driven from JS instead. This is
// the one shared source of truth for "how wide is the screen right now" - every
// component that needs to change layout for phone/tablet reads from here instead of
// each rolling its own resize listener.
const MOBILE_MAX = 640;
const TABLET_MAX = 1024;

function classify(width) {
  if (width <= MOBILE_MAX) return 'mobile';
  if (width <= TABLET_MAX) return 'tablet';
  return 'desktop';
}

export function useViewport() {
  const [width, setWidth] = useState(() => (typeof window !== 'undefined' ? window.innerWidth : 1280));

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const breakpoint = classify(width);
  return {
    width,
    breakpoint,
    isMobile: breakpoint === 'mobile',
    isTablet: breakpoint === 'tablet',
    isDesktop: breakpoint === 'desktop',
    // mobile or tablet - for checks that only care "not full desktop width"
    isCompact: breakpoint !== 'desktop',
  };
}
